import { getHostInfo } from '../state/index.js';
/**
 * Get the config value after evaluating it
 */
export function evaluateConfig(config) {
    const { context } = getHostInfo();
    return config.evaluateWithContext(context);
}
//# sourceMappingURL=config.js.map